import React, { Component } from 'react';
import $, { data, event } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { tokenVerification } from "./Utils";
import TranslationPanel from "./TranslationPanel";

// Predefined patient messages are stored as codes. Show the sentence they stand for,
// not the raw code. Keep in sync with PatientMessageTranslationProvider on the server
// and with the predefined message options in the modal below.
const PREDEFINED_PATIENT_MESSAGES = {
    ER: "Proceed to the Emergency Room immediately",
    DOCTOR: "Call your doctor immediately",
    BUSINESS_HOURS: "Call your doctor during the next available business hours",
};

function resolvePreDefinedMessage(code) {
    if (!code) return "";
    return PREDEFINED_PATIENT_MESSAGES[code] || code;
}

class RiskRuleForProcedure extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            selectedRuleType: "",
            journals: [],
            medications: [],
            loadingJournals: false,
            riskFactors: [],
            selectedRiskFactorId: "",
            loadingRiskFactors: false,
            selectedComparison: "",
            thresholdValue: "",
            selectedJournalId: "",
            prefixOperator: "",
            selectedJournalTitle: "",
            selectedRiskFactorTitle: "",
            riskRules: {},
            selectedMedicationTitle: "",
            selectedMedicationId: "",
            riskRuleId: "",
            highThresholdValue: "",
            lowThresholdValue: "",
            noJournalEntryDays: "",
            isEditingRule: false,
            isRuleNameInputOpen: false,
            riskRuleName: "",
            riskFactorType: "",
            riskRuleCategory: "",
            mediumRiskOption: "",
            highRiskOption: "",
            parentRuleId: "",
            selectedHighRiskOptions: [],
            selectedMediumRiskOptions: [],
            customMessageModal: false,
            preDefinedMessage: "",
            customMessage: "",
            errorMessage: "",
            editPatientButton: {},
            messageId: "",
            selectedBaselineType: "",
            selectedBaseline: null,
            numberOfDaysAgo: "",
            highRiskDeviation: "",
            moderateRiskDeviation: "",
            showPatientMessageTranslation: false,
            patientMessageId: "",
            patientMessageContent: "",
        };
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }

    componentDidMount() {
        this.fetchRiskRules();
    }

    handleModalClose = () => {
        this.setState({
            showModal: false, loadingJournals: false, loadingRiskFactors: false,
            journals: [], riskFactors: [], lowThresholdValue: "", selectedComparison: "", highThresholdValue: "",
            selectedRuleType: "", selectedJournalId: "", selectedRiskFactorId: '', noJournalEntryDays: "",
            prefixOperator: "", riskRuleId: "", isEditingRule: false, selectedJournalTitle: "", selectedRiskFactorTitle: "",
            isRuleNameInputOpen: false, riskRuleName: "", riskFactorType: "", highRiskOption: "", riskRuleCategory: "",
            comparison: "", mediumRiskOption: "", parentRuleId: "", highRiskDeviation: "", moderateRiskDeviation: "", baseLine: "", baseLineType: "",
            numberOfDaysAgo: "", selectedBaseline: null, selectedBaselineType: ""
        });
    }

    hanldeRuleNameModal = (rule) => {
        this.setState({ isRuleNameInputOpen: true, riskRuleId: rule.id, riskRuleName: rule.riskRuleName });
    }



    handleModalShow = (type, item, rule, ruleNameInput) => {
        this.setState((prevState) => ({
            showModal: true,
            riskRuleId: rule ? rule.id : "",  // Clear riskRuleId when creating new rule, keep it when editing
            parentRuleId: (item && !rule) ? item.id : "",  // Set parent only when adding child, not when editing
            ...(item && !rule && {
                riskRuleName: item.riskRuleName
            }),
            prefixOperator: type === "OR" ? "OR" : type === "AND" ? "AND" : prevState.prefixOperator,
            ...((ruleNameInput && rule === "") && {
                isRuleNameInputOpen: true
            }),
            ...(rule && {
                selectedJournalId: rule.targetId,
                selectedRiskFactorId: rule.subTargetId,
                selectedRuleType: rule.type,
                prefixOperator: rule.prefixOperator,
                selectedJournalTitle: rule.targetName,
                selectedRiskFactorTitle: rule.subTargetName,
                parentRuleId: rule.parentRuleId,
                noJournalEntryDays: rule.noJournalEntryDays,
                lowThresholdValue: rule.lowThresholdValue,
                highThresholdValue: rule.highThresholdValue,
                selectedComparison: rule.comparison,
                riskRuleId: rule.id,
                loadingJournals: true,
                loadingRiskFactors: true,
                selectedJournalId: rule.targetId,
                selectedRiskFactorId: rule.subTargetId,
                selectedBaseline: rule.baseLine,
                selectedBaselineType: rule.baseLineType,
                numberOfDaysAgo: rule.numberOfDaysAgo,
                highRiskDeviation: rule.highRiskDeviation,
                moderateRiskDeviation: rule.moderateRiskDeviation,
                highRiskOption: rule.highRiskOption,
                mediumRiskOption: rule.mediumRiskOption,
                selectedHighRiskOptions: rule.highRiskOption ? rule.highRiskOption.split(",") : [],
                selectedMediumRiskOptions: rule.mediumRiskOption ? rule.mediumRiskOption.split(",") : [],
                riskFactorType: rule.riskFactorType,
                riskRuleCategory: rule.riskRuleCategory,
                ...(
                    (rule.highRiskOption === 'Yes' || rule.highRiskOption === 'No') &&
                    (rule.mediumRiskOption === 'Yes' || rule.mediumRiskOption === 'No')
                )
                    ? { riskFactorType: "BOOLEAN" }
                    : ((rule.highRiskOption === null && rule.mediumRiskOption === null)
                        ? { riskFactorType: "INTEGER" }

                        : (((rule.highRiskOption != null && rule.highRiskOption.includes(',')) || (rule.mediumRiskOption != null && rule.mediumRiskOption.includes(",")))
                            ? { riskFactorType: "MULTISELECT" }
                            : { riskFactorType: "SELECT" }))
                ,
                ...((rule.parentRuleId === null) && { riskRuleName: rule.riskRuleName })

            })
        }), () => {
            console.log("Modal should open, showModal:", this.state.showModal);
        });

        if (rule) {
            this.fetchJournals(rule);
        }
    };


    goBackProcedurePage = () => {
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        if (userRole == "PHYSICIAN") {
            this.props.history.push({
                pathname: "/projectmgmt",
            }
            )
        } else {
            this.props.history.push({
                pathname: "/projectmgmt/procedure",
            });
        }
    }

    fetchJournals = (rule) => {
        var thisController = this;
        var url;
        var data;
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        // if (userRole == "PHYSICIAN") {
        //     url = "/my-jeeva-api/fetch-provider-rules-journal";
        //     data = {
        //         userEmail: JSON.parse(localStorage.getItem("user_details"))["emailId"],
        //         procedureId: localStorage.getItem("procedureId")
        //     }
        // } else {
        //     url = "/my-jeeva-api/get-journals-for-procedure"
        //     data = {
        //         procedureId: localStorage.getItem("procedureId"),
        //         healthSystemId: localStorage.getItem("healthSystemId"),
        //         hospitalId: localStorage.getItem("hospitalId")
        //     }
        // }
        url = "/my-jeeva-api/get-journals-for-procedure"
        data = {
            procedureId: localStorage.getItem("procedureId"),
            healthSystemId: localStorage.getItem("healthSystemId"),
            hospitalId: localStorage.getItem("hospitalId")
        }
        $.ajax({
            url: url,
            type: 'GET',
            data: data,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.state.journals = res.result;
                    thisController.state.loadingJournals = false;
                    thisController.setState(thisController.state);
                    thisController.fetchJournalRiskFactors(rule.targetId)
                } else {
                    thisController.state.loadingJournals = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr, status, error) {

            }
        });
    }

    updateRiskRuleName = () => {
        var thisController = this;
        var riskRuleName = thisController.state.riskRuleName.trim();
        if (riskRuleName == "" || riskRuleName === null) {
            thisController.notifyEmptyRiskRuleName();
        } else {
            $.ajax({
                url: "/my-jeeva-api/update-risk-rule-name",
                type: 'GET',
                data: {
                    name: thisController.state.riskRuleName.trim(),
                    id: thisController.state.riskRuleId
                },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                success: function (res) {
                    if (res.success == true) {
                        thisController.fetchRiskRules();
                        thisController.handleModalClose();
                    }
                },
                error: function (xhr, status, error) {

                }
            });
        }

    }

    handleDropdownChange = (event) => {
        var thisController = this;
        this.setState({
            selectedRuleType: event.target.value, journals: [], loadingJournals: true, loadingRiskFactors: false, riskFactors: [], selectedJournalId: "",
            selectedJournalTitle: "", selectedRiskFactorId: "", selectedRiskFactor: "", selectedMedicationId: "", selectedMedicationTitle: "",
            riskRuleCategory: ""
        },
            () => {
                if (thisController.state.selectedRuleType === "JOURNAL_ENTRY_VALUE" || thisController.state.selectedRuleType === "NO_JOURNAL_ENTRY") {
                    var url;
                    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
                    var data;
                    // if (userRole == "PHYSICIAN") {
                    //     url = "/my-jeeva-api/fetch-provider-rules-journal"
                    //     data = {
                    //         userEmail: JSON.parse(localStorage.getItem("user_details"))["emailId"],
                    //         procedureId: localStorage.getItem("procedureId")
                    //     }
                    // } else {
                    //     url = "/my-jeeva-api/get-journals-for-procedure"
                    //     data = {
                    //         procedureId: localStorage.getItem("procedureId"),
                    //         healthSystemId: localStorage.getItem("healthSystemId"),
                    //         hospitalId: localStorage.getItem("hospitalId")
                    //     }
                    // }
                    url = "/my-jeeva-api/get-journals-for-procedure"
                    data = {
                        procedureId: localStorage.getItem("procedureId"),
                        healthSystemId: localStorage.getItem("healthSystemId"),
                        hospitalId: localStorage.getItem("hospitalId")
                    }
                    $.ajax({
                        url: url,
                        type: 'GET',
                        data: data,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("access_token"),
                        },
                        success: function (res) {
                            if (res.success == true) {
                                thisController.state.journals = res.result;
                                thisController.state.loadingJournals = false;
                                thisController.setState(thisController.state);
                            } else {
                                thisController.state.loadingJournals = false;
                                thisController.setState(thisController.state);
                            }
                        },
                        error: function (xhr, status, error) {

                        }
                    });
                }

            });
    }

    handleJournalDropdownChange = (event) => {
        var thisController = this;
        thisController.state.selectedJournalId = event.target.value;
        var selectedJournal = this.state.journals.find(journal => journal.id === event.target.value);
        var selectedJournalTitle = selectedJournal ? selectedJournal.title : '';
        thisController.state.selectedJournalTitle = selectedJournalTitle;
        thisController.state.selectedComparison = "";
        thisController.state.selectedRiskFactorId = "";
        thisController.state.selectedRiskFactorTitle = "";
        thisController.state.riskFactorType = "";
        thisController.setState(thisController.state)
        thisController.fetchJournalRiskFactors();
    }

    handleRiskRuleCategory = (event) => {
        this.state.riskRuleCategory = event.target.value;
        this.state.selectedJournalId = "";
        this.state.selectedJournalTitle = "";
        this.setState(this.state);
    }

    handleMedicationDropdownChange = (event) => {
        this.state.selectedMedicationId = event.target.value;
        var selectedMedication = this.state.medications.find(medication => medication.id === event.target.value);
        var selectedMedicationTitle = selectedMedication ? selectedMedication.name : '';
        this.state.selectedMedicationTitle = selectedMedicationTitle;
        this.setState(this.state)

    }
    handleHighRiskOption = (event) => {
        const { riskFactorType, highRiskOption } = this.state;
        let newChosenOption;

        if (riskFactorType === "MULTISELECT") {
            const selectedOptions = new Set(highRiskOption.split(',').filter(opt => opt));
            if (event.target.checked) {
                selectedOptions.add(event.target.value);
            } else {
                selectedOptions.delete(event.target.value);
            }
            newChosenOption = Array.from(selectedOptions).join(',');
        } else {
            newChosenOption = event.target.value;
        }

        this.setState({ highRiskOption: newChosenOption });
        console.log("highRiskOption", newChosenOption);
    }

    handleMediumRiskOption = (event) => {
        const { riskFactorType, mediumRiskOption } = this.state;
        let newChosenOption;

        if (riskFactorType === "MULTISELECT") {
            const selectedOptions = new Set(mediumRiskOption.split(',').filter(opt => opt));
            if (event.target.checked) {
                selectedOptions.add(event.target.value);
            } else {
                selectedOptions.delete(event.target.value);
            }
            newChosenOption = Array.from(selectedOptions).join(',');
        } else {
            newChosenOption = event.target.value;
        }

        this.setState({ mediumRiskOption: newChosenOption });
        console.log("mediumRiskOption", newChosenOption);
    }


    fetchJournalRiskFactors = () => {
        var thisController = this;
        thisController.setState({ loadingRiskFactors: true });

        $.ajax({
            url: "/my-jeeva-api/get-risk-factors",
            type: 'GET',
            data: {
                journalId: thisController.state.selectedJournalId,
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.state.riskFactors = res.result;
                    thisController.state.loadingRiskFactors = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.state.loadingRiskFactors = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr, status, error) {

            }
        });
    }

    fetchRiskRules = () => {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/get-risk-rules-procedure",
            type: 'GET',
            data: {
                procedureId: localStorage.getItem("procedureId"),
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.state.riskRules = res.result;
                    for (const parentRuleId in res.result) {
                        if (res.result.hasOwnProperty(parentRuleId)) {
                            thisController.checkPatientMessage(parentRuleId);
                        }
                    }
                    thisController.setState(thisController.state);
                } else {

                }
            },
            error: function (xhr, status, error) {

            }
        });
    }

    checkPatientMessage = (parentRuleId) => {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/check-patient-message",
            type: 'GET',
            data: {
                parentRuleId: parentRuleId
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    if (res.result.length > 0) {
                        thisController.setState(prevState => ({
                            editPatientButton: {
                                ...prevState.editPatientButton,
                                [parentRuleId]: true
                            }
                        }),
                        );
                    }
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr, status, error) {

            }
        });
    }



    handleRiskFactorDropdownChange = (event) => {
        this.state.selectedRiskFactorId = event.target.value;
        var selectedRiskFactor = this.state.riskFactors.find(riskFactor => riskFactor.journalItemId === event.target.value);
        var selectedRiskFactorTitle = selectedRiskFactor ? selectedRiskFactor.name : '';
        var riskFactorType = selectedRiskFactor ? selectedRiskFactor.journalItemType : '';
        this.state.riskFactorType = riskFactorType;
        this.state.selectedRiskFactorTitle = selectedRiskFactorTitle;
        this.state.mediumRiskOption = "";
        this.state.highRiskOption = "";
        this.state.lowThresholdValue = "";
        this.state.highThresholdValue = "";
        this.setState(this.state)
    }

    handleComparisonChange = (event) => {
        this.setState({ selectedComparison: event.target.value });
    }

    handleBaseLinetypeChange = (event) => {
        this.setState({ selectedBaselineType: event.target.value });
    }
    handleBaseLineChange = (event) => {
        this.setState({ selectedBaseline: event.target.value });
    }

    handleNumberChange = (event) => {
        this.setState({ noJournalEntryDays: event.target.value });
    }
    handleRiskRuleNameChange = (event) => {
        var riskRuleName = event.target.value;
        this.state.riskRuleName = riskRuleName;
        this.setState(this.state);
    }
    handleHighThresholdChange = (event) => {
        this.setState({ highThresholdValue: event.target.value });
    }

    handleLowThresholdChange = (event) => {
        this.setState({ lowThresholdValue: event.target.value });
    }
    handleHighRiskDeviationChange = (event) => {
        this.setState({ highRiskDeviation: event.target.value });
    }

    handleModerateRiskDeviationChange = (event) => {
        this.setState({ moderateRiskDeviation: event.target.value });
    }

    // A focused number input counts a wheel scroll as a value change, so scrolling
    // the form rewrites whatever was last typed. Drop focus instead.
    blurOnWheel = (event) => {
        event.target.blur();
    }

    // handleNumberOfDaysAgo = (event) => {
    //     this.setState({ numberOfDaysAgo: event.target.value });
    // }

    handleNumberOfDaysAgo = (e) => {
        const value = Number(e.target.value);

        if (value <= 0 && e.target.value !== "") {
            this.notifyNegativeNumber();
        } else {
            this.setState({ numberOfDaysAgo: e.target.value });
        }
    };



    saveRiskRule = () => {
        var thisController = this;
        var patientAdmissionId = null;
        var riskRuleName = thisController.state.riskRuleName.trim();
        var treatmentId = localStorage.getItem("procedureId");
        var targetId = thisController.state.selectedJournalId;
        var subTargetId = thisController.state.selectedRiskFactorId;
        var type = thisController.state.selectedRuleType;
        var prefixOperator = thisController.state.prefixOperator;
        var targetName = thisController.state.selectedJournalTitle;
        var subTargetName = thisController.state.selectedRiskFactorTitle;
        var riskFactorType = thisController.state.riskFactorType;
        var numberOfDaysAgo = thisController.state.numberOfDaysAgo;
        var highRiskDeviation = thisController.state.highRiskDeviation;
        var moderateRiskDeviation = thisController.state.moderateRiskDeviation;
        // Typing gives a string while an edited rule loads a number, and two strings
        // compare as text - "9" > "10" - so compare the deviations as numbers
        var parsedHighDeviation = Number(highRiskDeviation);
        var parsedModerateDeviation = Number(moderateRiskDeviation);
        var baseLineType = thisController.state.selectedBaselineType;
        var baseLine = thisController.state.selectedBaseline;
        var id = thisController.state.riskRuleId;
        if (prefixOperator == "") {
            prefixOperator = null;
        }

        var parentRuleId = thisController.state.parentRuleId;

        if (parentRuleId == "") {
            parentRuleId = null;
        } else {
            riskRuleName = "";
        }
        if (riskRuleName == "") {
            riskRuleName = null;
        }
        var riskRuleCategory = thisController.state.riskRuleCategory;
        var noJournalEntryDays = thisController.state.noJournalEntryDays;
        var lowThresholdValue = thisController.state.lowThresholdValue;
        var highThresholdValue = thisController.state.highThresholdValue;
        if (highThresholdValue) {
            var parsedHighValue = Number(highThresholdValue);
        }
        if (lowThresholdValue) {
            var parsedModerateValue = Number(lowThresholdValue);
        }

        var comparison = thisController.state.selectedComparison;
        if (comparison == "") {
            comparison = null;
        }
        var highRiskOption = thisController.state.highRiskOption;
        if (highRiskOption === "") {
            highRiskOption = null;
        }
        var mediumRiskOption = thisController.state.mediumRiskOption;
        if (mediumRiskOption === "") {
            mediumRiskOption = null;
        }
        if (baseLineType === "") {
            baseLineType = null;
        }

        if (baseLine === "") {
            baseLine === null;
        }
        if (baseLineType === "STATIC_BASELINE") {
            baseLine === null;
        }
        var url;
        var methodType;
        if (id) {
            url = "/my-jeeva-api/update-risk-rule"
            methodType = "PATCH"
        } else {
            url = "/my-jeeva-api/save-risk-rule"
            methodType = "POST"
        }
        if (riskRuleName == null && parentRuleId == null && methodType == "POST") {
            thisController.notifyEmptyRiskRuleName();
        } else if (type == "") {
            thisController.notifyEmptyTypeName();
        } else if (targetId == "") {
            thisController.notifyEmptyTargetName();
        } else if (thisController.state.riskFactors.length === 0) {
            thisController.notifyAddNewRiskFactor();
        } else if (subTargetId == "") {
            thisController.notifyEmptySubTargetName();
        } else if (riskFactorType === "INTEGER" && comparison == null) {
            thisController.notifyEmptyComparison();
        } else if (riskFactorType === "INTEGER" && baseLineType === "STATIC_BASLINE" && (highThresholdValue == "" && lowThresholdValue == "")) {
            thisController.notifyEmptyThresholdValue();
        } else if (riskFactorType === "INTEGER" && (comparison == "GREATER_THAN" || comparison == "GREATER_THAN_OR_EQUALS_TO") && (parsedHighValue < parsedModerateValue)) {
            thisController.notifyHighIsLessThanModerateValue();
        } else if (riskFactorType === "INTEGER" && lowThresholdValue != 0 && baseLineType === "STATIC_BASLINE" && (comparison == "LESS_THAN" || comparison == "LESS_THAN_OR_EQUALS_TO") && (parsedModerateValue < parsedHighValue)) {
            thisController.notifyModerateIsLessThanHighValue();
        } else if (riskFactorType === "INTEGER" && baseLineType === "STATIC_BASLINE" && (highThresholdValue == lowThresholdValue)) {
            thisController.notifySameHighAndModerateValue();
        } else if ((riskFactorType === "SELECT" || riskFactorType === "MULTISELECT" || riskFactorType === "BOOLEAN") && (highRiskOption == null && mediumRiskOption == null)) {
            thisController.notifyEmptyOptionFeild();
        } else if ((riskFactorType === "SELECT") && mediumRiskOption === highRiskOption) {
            thisController.notifySameRiskOption();
        } else if (riskFactorType === "INTEGER" && baseLineType === "FLOATING_BASELINE" && parsedModerateDeviation > parsedHighDeviation) {
            thisController.notifyHighIsLessThanModerateDeviation();
        } else if (riskFactorType === "INTEGER" && baseLineType === "FLOATING_BASELINE" && parsedModerateDeviation === parsedHighDeviation) {
            thisController.notifySameHighAndModerateDeviation();
        }
        else {
            var saveData = {
                patientAdmissionId: patientAdmissionId,
                treatmentId: treatmentId,
                targetId: targetId,
                subTargetId: subTargetId,
                type: type,
                prefixOperator: prefixOperator,
                noJournalEntryDays: noJournalEntryDays,
                lowThresholdValue: lowThresholdValue,
                highThresholdValue: highThresholdValue,
                comparison: comparison,
                targetName: targetName,
                subTargetName: subTargetName,
                parentRuleId: parentRuleId,
                riskRuleName: riskRuleName,
                highRiskOption: highRiskOption,
                mediumRiskOption: mediumRiskOption,
                baseLine: baseLine,
                baseLineType: baseLineType,
                numberOfDaysAgo: numberOfDaysAgo,
                highRiskDeviation: highRiskDeviation,
                moderateRiskDeviation: moderateRiskDeviation

            }
            if (id) {
                saveData.id = id;
            }
            $.ajax({
                url: url,
                type: methodType,
                data: JSON.stringify(saveData),
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                },
                success: function (res) {
                    if (res.success == true) {
                        thisController.handleModalClose();
                        thisController.fetchRiskRules();
                    }
                },
                error: function (xhr, status, error) {

                }
            });
        }
    }

    handleDeleteRule = (ruleId) => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/delete-rule/" + ruleId,
            method: 'DELETE',
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.fetchRiskRules();
                } else {
                    console.log("Rule deletion failed");
                }
            },
            error: function (xhr, status, error) {

            }
        });
    }


    notifyEmptyFeilds() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please fill all the fields before saving
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyNegativeNumber() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Number of days ago can not be a negative number
            </b>,
            {
                position: "top-center",
            }
        );
    }


    notifyEmptyRiskRuleName() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please enter risk rule name
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyEmptyTargetName() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please select journal field
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyAddNewRiskFactor() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;No risk factors found. Please add a new risk factor.
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyEmptySubTargetName() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please select risk factor field
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyHighIsLessThanModerateValue() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;High risk value must be greater than Low risk value.
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyHighIsLessThanModerateDeviation() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;High risk deviation must be greater than Moderate risk deviation.
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyModerateIsLessThanHighValue() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;High risk value must be less than Low risk value.
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifySameHighAndModerateValue() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;High threshold value must not be same as moderate threshold value
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifySameHighAndModerateDeviation() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;High risk deviation must not be same as moderate deviation value
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyEmptyComparison() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please select comparison
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyEmptyTypeName() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please select rule type
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyEmptyThresholdValue() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please enter a high and/or moderate threshold value
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyEmptyLowThresholdValue() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please enter low threshold value
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyEmptyOptionFeild() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please select high risk or moderate risk option
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifySameRiskOption() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please select different high risk and moderate risk option
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyEmptyAlertMessage() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Please enter custom patient message
            </b>,
            {
                position: "top-center",
            }
        );
    }

    getComparisonSymbol(comparison) {
        switch (comparison) {
            case 'GREATER_THAN':
                return '>';
            case 'LESS_THAN':
                return '<';
            case 'EQUALS_TO':
                return '=';
            case 'GREATER_THAN_OR_EQUALS_TO':
                return '≥';
            case 'LESS_THAN_OR_EQUALS_TO':
                return '≤';
            default:
                return '';
        }
    }

    getRuleString(rule, riskCategory) {
        var comparisonSymbol = this.getComparisonSymbol(rule.comparison);

        if (riskCategory === "High") {
            if (rule.baseLineType === "FLOATING_BASELINE") {
                if (rule.baseLine === "YESTERDAY") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} Yesterday {rule.highRiskDeviation < 0 ? rule.highRiskDeviation : `+${rule.highRiskDeviation}`}
                        </React.Fragment>
                    )
                } else if (rule.baseLine === "FIRST_DATAPOINT") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} initial baseline value {rule.highRiskDeviation < 0 ? rule.highRiskDeviation : `+${rule.highRiskDeviation}`}
                        </React.Fragment>
                    )

                } else if (rule.baseLine === "CUSTOM_NUMBER_OF_DAYS_AGO") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} {rule.numberOfDaysAgo} days ago {rule.highRiskDeviation < 0 ? rule.highRiskDeviation : `+${rule.highRiskDeviation}`}
                        </React.Fragment>
                    )
                }

            } else {
                if(rule.highRiskOption !== null && (rule.highRiskOption === "Yes" || rule.highRiskOption === "No")){
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}(Yes/no)) is {rule.highRiskOption}
                        </React.Fragment>
                    )
                }
                if (rule.highRiskOption !== null) {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) is {rule.highRiskOption}
                        </React.Fragment>
                    )
                } 
                
                else if (rule.highThresholdValue === 0) {
                    if (rule.highRiskOption === null) {
                        return (
                            <React.Fragment>
                                <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>-</span>
                            </React.Fragment>
                        )
                    }
                } else if (rule.type === "NO_JOURNAL_ENTRY") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} {rule.noJournalEntryDays}
                        </React.Fragment>
                    )
                } else if (rule.type === "JOURNAL_ENTRY_VALUE") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} {rule.highThresholdValue}
                        </React.Fragment>
                    );
                }
               
            }

        } else if (riskCategory === "Moderate") {
            if (rule.baseLineType === "FLOATING_BASELINE") {
                if (rule.baseLine === "YESTERDAY") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} Yesterday  {rule.moderateRiskDeviation < 0 ? rule.moderateRiskDeviation : `+${rule.moderateRiskDeviation}`}


                        </React.Fragment>
                    )
                } else if (rule.baseLine === "FIRST_DATAPOINT") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} initial baseline value {rule.moderateRiskDeviation < 0 ? rule.moderateRiskDeviation : `+${rule.moderateRiskDeviation}`}
                        </React.Fragment>
                    )
                } else if (rule.baseLine === "CUSTOM_NUMBER_OF_DAYS_AGO") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} {rule.numberOfDaysAgo} days ago {rule.moderateRiskDeviation < 0 ? rule.moderateRiskDeviation : `+${rule.moderateRiskDeviation}`}
                        </React.Fragment>
                    )
                }

            } else {
                if(rule.mediumRiskOption !== null && (rule.mediumRiskOption === "Yes" || rule.mediumRiskOption === "No")){
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}(Yes/no)) is {rule.mediumRiskOption}
                        </React.Fragment>
                    )
                }
                
                if (rule.mediumRiskOption !== null) {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) is {rule.mediumRiskOption}
                        </React.Fragment>
                    )
                }
                else if (rule.lowThresholdValue === 0) {
                    if (rule.mediumRiskOption === null) {
                        return (
                            <React.Fragment>
                                <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>-</span>
                            </React.Fragment>
                        )
                    }
                } else if (rule.type === "NO_JOURNAL_ENTRY") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} {rule.noJournalEntryDays}
                        </React.Fragment>
                    )
                } else if (rule.type === "JOURNAL_ENTRY_VALUE") {
                    return (
                        <React.Fragment>
                            ({rule.targetName}  <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}> &rarr; </span> {rule.subTargetName}) {comparisonSymbol} {rule.lowThresholdValue}
                        </React.Fragment>
                    );
                }
            }

        }
    }

    openDeletePopUp = (id, riskRuleName) => {
        confirmAlert({
            title: "Confirm to Delete",
            message: riskRuleName ? `Are you sure you want to delete ${riskRuleName} ?` : `Are you sure you want to delete this rule component ?`,
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.handleDeleteRule(id),
                },
                {
                    label: "No",
                },
            ],
        });
    };

    handleEdit = () => {
        this.setState({ isEditingRule: true });
    }

    showCustomAlertModal = (rule) => {
        this.fetchPatientMessage(rule);

    }

    handleCustomMessageModalClose = () => {
        this.setState({ customMessageModal: false, riskRuleId: "", riskRuleName: "", preDefinedMessage: "", customMessage: "", errorMessage: "" });
    }

    handlePreDefinedMessageChange = (event) => {
        // var preDefinedMessage;
        // if (event.target.value === "ER") {
        //     preDefinedMessage = "Proceed to the ER immediately";
        // } else if (event.target.value === "DOCTOR") {
        //     preDefinedMessage = "Call your doctor immediately"
        // } else {
        //     preDefinedMessage = "Call you doctor during the next available business hours"
        // }
        // this.setState({
        //     preDefinedMessage: preDefinedMessage,
        //     customMessage: ""
        // });
        const selectedValue = event.target.value;

        // Update state with the selected value directly
        this.setState({
            preDefinedMessage: selectedValue,
            customMessage: ""
        });
    }

    handleCustomMessageChange = (event) => {
        var customMessage = event.target.value;
        if (customMessage.length > 150) {
            this.setState({
                customMessage: customMessage,
                errorMessage: " Custom message cannot exceed 150 characters."
            });
            return;
        } else {
            this.setState({
                preDefinedMessage: "",
                customMessage: customMessage,
                errorMessage: "" // Clear error when valid
            });
        }
    }

    savePatientMessage = () => {
        var thisController = this;

        var preDefinedMessage = thisController.state.preDefinedMessage;
        var customMessage = thisController.state.customMessage;
        if (customMessage.length > 150) {
            this.setState({ errorMessage: "Custom message cannot exceed 150 characters." });
            return;
        } else if (preDefinedMessage === "" && customMessage === "") {
            thisController.notifyEmptyAlertMessage();
        } else {
            var patientMessgeData = {
                parentRuleId: thisController.state.riskRuleId,
                riskRuleName: thisController.state.riskRuleName,
                preDefinedMessage: preDefinedMessage,
                customMessage: customMessage,
                treatmentId: localStorage.getItem("procedureId")
            }
            $.ajax({
                url: "/my-jeeva-api/save-patient-message",
                data: JSON.stringify(patientMessgeData),
                method: 'POST',
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                success: function (res) {
                    if (res.success == true) {
                        // thisController.fetchPatientMessage();
                        thisController.setState(prevState => ({
                            editPatientButton: {
                                ...prevState.editPatientButton,
                                [thisController.state.riskRuleId]: true
                            },
                            customMessageModal: false,
                            preDefinedMessage: "",
                            customMessage: "",
                        }),
                        );
                    } else {
                        console.log("SAVE FAILED FOR PATIENT MESSAGE");
                    }
                },
                error: function (xhr, status, error) {

                }
            });
        }

    }
    openDeletePopUpForPatientMessage = () => {
        confirmAlert({
            title: "Confirm to Delete",
            message: `Are you sure you want to delete this message ?`,
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.deletePatientMessage(),
                },
                {
                    label: "No",
                },
            ],
        });
    };
    deletePatientMessage = () => {
        var thisController = this;
        var messageId = thisController.state.messageId;
        $.ajax({
            url: "/my-jeeva-api/delete-patient-message/" + messageId,
            method: 'DELETE',
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.setState(prevState => ({
                        editPatientButton: {
                            ...prevState.editPatientButton,
                            [thisController.state.riskRuleId]: false
                        },
                        messageId: "",
                        customMessageModal: false,
                        preDefinedMessage: "",
                        customMessage: "",
                        riskRuleId: "",
                        riskRuleName: ""
                    })
                    )
                    thisController.fetchRiskRules();
                } else {
                    console.log("message deletion failed");
                }
            },
            error: function (xhr, status, error) {

            }
        });
    }
    fetchPatientMessage = (rule) => {
        var thisController = this;
        var parentRuleId;
        if (rule) {
            parentRuleId = rule.id
        } else {
            parentRuleId = thisController.state.riskRuleId;
        }

        $.ajax({
            url: "/my-jeeva-api/fetch-patient-message",
            data: {
                parentRuleId: parentRuleId
            },
            method: 'GET',
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.setState({
                        customMessageModal: true,
                        ...(rule && { riskRuleId: rule.id, riskRuleName: rule.riskRuleName }),
                        preDefinedMessage: res.result.preDefinedMessage,
                        customMessage: res.result.customMessage,
                        messageId: res.result.id
                    });
                } else {
                    thisController.setState({
                        customMessageModal: true,
                        ...(rule && { riskRuleId: rule.id, riskRuleName: rule.riskRuleName })
                    });
                    console.log("FETCH FAILED FOR PATIENT MESSAGE");
                }
            },
            error: function (xhr, status, error) {

            }
        });

    }

    showPatientMessageTranslation = (rule) => {
        var thisController = this;
        // Fetch the patient message first
        $.ajax({
            url: "/my-jeeva-api/fetch-patient-message",
            data: {
                parentRuleId: rule.id
            },
            method: 'GET',
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    // Combine preDefinedMessage and customMessage
                    const messageContent = res.result.customMessage
                        || resolvePreDefinedMessage(res.result.preDefinedMessage)
                        || "";
                    thisController.setState({
                        showPatientMessageTranslation: true,
                        patientMessageId: rule.id,
                        patientMessageContent: messageContent
                    });
                } else {
                    thisController.setState({
                        showPatientMessageTranslation: true,
                        patientMessageId: rule.id,
                        patientMessageContent: ""
                    });
                }
            },
            error: function (err) {
                console.error("Error fetching patient message:", err);
                thisController.setState({
                    showPatientMessageTranslation: true,
                    patientMessageId: rule.id,
                    patientMessageContent: ""
                });
            }
        });
    }

    closePatientMessageTranslation = () => {
        this.setState({
            showPatientMessageTranslation: false,
            patientMessageId: "",
            patientMessageContent: ""
        });
    }

    render() {
        const { riskRules } = this.state;
        console.log("riskRules", riskRules);
        const riskRulesArray = Object.values(riskRules).flat();

        const groupedRules = riskRulesArray.reduce((acc, rule) => {
            const key = rule.parentRuleId || rule.id;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(rule);
            return acc;
        }, {});

        const ruleSets = Object.values(groupedRules);

        return (
            <div>
                <link rel="stylesheet" href="assets/css/riskRule.css" />
                <ToastContainer className="Toast-at-center" />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <img
                        className="img-responsive"
                        src="./assets/images/arrow.svg"
                        onClick={this.goBackProcedurePage}
                        style={{ cursor: "pointer" }}
                    />
                    <h6 className="nav-item" style={{ color: "#282a65", marginTop: "10px", fontSize: "20px" }}>
                        Configure Risk Rules for {localStorage.getItem("procedureName")}
                    </h6>
                    <button type="button" className='btn2 table-action-button'
                        style={{
                            marginRight: "2vw", marginTop: "2vh", backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                ? "#282a6596"
                                : "#282a65"
                        }}

                        onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null :
                            () => this.handleModalShow("", "", "", "ruleNameInput")}>Add Risk Rule</button>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <h6 style={{ color: "#282a65", marginTop: "-8px", fontSize: "12px", marginRight: "7vw" }}>
                        All rule components must be satisfied to trigger a Risk Rule
                    </h6>
                </div>
                {ruleSets.map((ruleSet, index) => (
                    <div key={index} className="risk-rule-set">
                        {ruleSet.map((ruleObject, id) => (
                            <div
                            >
                                {ruleObject.riskRuleName != null &&
                                    (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <h5 style={{ marginLeft: "1vw", color: "#282a65" }}>
                                                {ruleObject.riskRuleName != null && `Rule Name :  ${ruleObject.riskRuleName}`}
                                            </h5>
                                            <div>
                                                <button
                                                    style={{
                                                        backgroundColor: "#ffffff",
                                                        border: "none",
                                                        marginLeft: "-6px",
                                                    }}
                                                >
                                                    <img
                                                        className="img-responsive"
                                                        title="Edit"
                                                        style={{
                                                            marginTop: "6px",
                                                            backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")) ? "#282a6596" : "#282a65",
                                                            borderRadius: "5px",
                                                            padding: "1px",
                                                        }}
                                                        src={this.editImageSrc}
                                                        onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null
                                                            : () => this.hanldeRuleNameModal(ruleObject)}
                                                    />
                                                </button>
                                                <button
                                                    style={{
                                                        backgroundColor: "#ffffff",
                                                        border: "none",
                                                        marginLeft: "3px",
                                                    }}
                                                    title="Delete"
                                                >
                                                    <img
                                                        className="img-responsive"
                                                        src={"./assets/images/baseline_delete_white_24dp.png"}
                                                        style={{
                                                            marginTop: "6px",
                                                            backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")) ? "#282a6596" : "#282a65",
                                                            borderRadius: "5px",
                                                            padding: "1px",
                                                        }}
                                                        onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null
                                                            : () => ruleObject.riskRuleName && this.openDeletePopUp(ruleObject.id, ruleObject.riskRuleName)}
                                                    />
                                                </button>
                                            </div>
                                        </div>)
                                }
                            </div>))
                        }

                        <table className="risk-rule-table">
                            <thead>
                                <tr>
                                    <th>Based On</th>
                                    <th>High Risk Rule</th>
                                    <th>Moderate Risk Rule</th>
                                    <th>Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {ruleSet.map((rule, idx) => (
                                    <React.Fragment key={idx}>
                                        <tr>
                                            <td>{rule.type ? rule.type.charAt(0).toUpperCase() + rule.type.slice(1).toLowerCase().replace(/_/g, ' ') : ""}</td>
                                            <td>{this.getRuleString(rule, "High")}</td>
                                            <td>{this.getRuleString(rule, "Moderate")}</td>
                                            <td>
                                                <button
                                                    style={{
                                                        backgroundColor: "#ffffff",
                                                        border: "none",
                                                        marginLeft: "-6px",
                                                    }}
                                                >
                                                    <img
                                                        className="img-responsive"
                                                        title="Edit"
                                                        style={{
                                                            marginTop: "6px",
                                                            backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")) ? "#282a6596" : "#282a65",
                                                            borderRadius: "5px",
                                                            padding: "1px",
                                                        }}
                                                        src={this.editImageSrc}
                                                        onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null :
                                                            () => this.handleModalShow("", "", rule, "ruleNameInput")}
                                                    />
                                                </button>
                                                <button
                                                    style={{
                                                        backgroundColor: "#ffffff",
                                                        border: "none",
                                                        marginLeft: "3px",
                                                    }}
                                                    title="Delete"
                                                >
                                                    <img
                                                        className="img-responsive"
                                                        src={"./assets/images/baseline_delete_white_24dp.png"}
                                                        style={{
                                                            marginTop: "6px",
                                                            backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                                                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")) ? "#282a6596" : "#282a65",
                                                            borderRadius: "5px",
                                                            padding: "1px",
                                                        }}
                                                        onClick={
                                                            this.userDetails["userRole"] === "PHYSICIAN" &&
                                                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null : () => { this.openDeletePopUp(rule.id); this.handleEdit() }}
                                                    />
                                                </button>
                                            </td>
                                        </tr>
                                        {idx < ruleSet.length - 1 && (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "center", padding: "10px 0", fontWeight: "bold" }}>AND</td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>

                        <div className="logic-buttons">
                            <button
                                style={{
                                    backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                        ? "#282a6596"
                                        : "#282a65"
                                }}
                                onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null :
                                    () => { this.handleModalShow("AND", ruleSet[0]); this.handleEdit() }} className="logic-button">Add Rule Component</button>
                            <button
                                style={{
                                    backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")
                                        ? "#282a6596"
                                        : this.state.editPatientButton[ruleSet[0].id] ? "#00A651" : "#282a65"
                                }}
                                onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null :
                                    () => { this.showCustomAlertModal(ruleSet[0]) }} className="logic-button">
                                {this.state.editPatientButton[ruleSet[0].id] ? "Edit Patient Message"
                                    : "Add Patient Message"
                                }

                            </button>
                        </div>
                    </div>
                ))}

                {this.state.isRuleNameInputOpen && (
                    <div className="modal" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content" style={{ height: "100%", borderRadius: "10px" }}>
                                <div style={{ alignItems: "center" }}>
                                    <h5 className="modal-title" style={{ color: "#282a65", fontWeight: "bold", display: "flex", justifyContent: "center" }} >Update Risk Rule</h5>
                                    <button type="button" style={{ marginTop: "-2.6vh" }}
                                        className="close" onClick={this.handleModalClose}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label style={{ display: this.state.isEditingRule && "block", fontWeight: "bold", color: "black", display: "flex" }}>Risk Rule Name</label>
                                        <input
                                            type="text"
                                            value={this.state.riskRuleName}
                                            placeholder='Enter risk rule name'
                                            onChange={this.handleRiskRuleNameChange}
                                            style={{
                                                border: "2px solid #777676",
                                                borderRadius: "10px",
                                                padding: "10px",
                                                height: "2.5vh",
                                            }}
                                        />
                                        <hr />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary"
                                        onClick={this.updateRiskRuleName}
                                    >
                                        Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.customMessageModal && (
                    <div className="modal" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content" style={{ height: "100%", borderRadius: "10px" }}>
                                <div style={{ alignItems: "center" }}>
                                    <h5 className="modal-title" style={{ color: "#282a65", fontWeight: "bold", display: "flex", justifyContent: "center" }} >Add Patient Message</h5>
                                    <h6 style={{ color: "#282a65", display: "flex", justifyContent: "center", fontSize: "13px", marginTop: "1vh" }}>This message will be displayed on the patient application when the high-risk rule is triggered.</h6>
                                    <button type="button" style={{ marginTop: "-7.7vh" }} className="close"
                                        onClick={this.handleCustomMessageModalClose}
                                    >
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div style={{ display: 'flex', justifyContent: "center", width: "23.7vw", marginTop: "2vh" }}>
                                        <select style={{ width: "auto" }} value={this.state.preDefinedMessage}
                                            onChange={this.handlePreDefinedMessageChange}
                                        >
                                            <option value="" disabled selected hidden>Select predefined message</option>
                                            <option value="ER">Proceed to the Emergency Room immediately</option>
                                            <option value="DOCTOR">Call your doctor immediately</option>
                                            <option value="BUSINESS_HOURS">Call your doctor during the next available business hours</option>
                                        </select>
                                        <hr />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: "center", marginTop: "3vh" }}>
                                        <h4>OR</h4>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: "center", marginTop: "2vh" }}>

                                        {/* <label style={{ display: this.state.isEditingRule && "block", fontWeight: "bold", color: "black", display: "flex", justifyContent: "center" }}>Custom Message</label> */}
                                        <textarea
                                            type="text"
                                            value={this.state.customMessage}
                                            placeholder='Enter custom message'
                                            onChange={this.handleCustomMessageChange}
                                            style={{
                                                border: "2px solid #777676",
                                                borderRadius: "10px",
                                                padding: "10px",
                                                height: "12.5vh",
                                                width: "40vw"
                                            }}
                                        />
                                    </div>
                                    {this.state.errorMessage && (
                                        <div style={{ color: "red", marginTop: "7px", textAlign: "center", fontSize: "1.15em" }}>
                                            {this.state.errorMessage}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
                                    <button
                                        type="button"
                                        title="Save"
                                        onClick={this.savePatientMessage}
                                        style={{
                                            backgroundColor: "#ffffff",
                                            border: "none",
                                            padding: "0",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <img
                                            src="./assets/images/baseline_save_white_24dp.png"
                                            alt="save"
                                            style={{
                                                width: "24px",
                                                height: "24px",
                                                backgroundColor: "#282a65",
                                                borderRadius: "5px",
                                                padding: "1px"
                                            }}
                                        />
                                    </button>

                                    {this.state.messageId && (
                                        <button
                                            type="button"
                                            title="Translate Patient Message"
                                            onClick={() => {
                                                this.setState({
                                                    showPatientMessageTranslation: true,
                                                    patientMessageId: this.state.messageId,
                                                    patientMessageContent: this.state.customMessage
                                                        || resolvePreDefinedMessage(this.state.preDefinedMessage)
                                                        || ""
                                                });
                                            }}
                                            style={{
                                                backgroundColor: "#ffffff",
                                                border: "none",
                                                padding: "0",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <img
                                                src="./assets/images/translate_white_24dp.svg"
                                                alt="translate"
                                                style={{
                                                    width: "24px",
                                                    height: "24px",
                                                    backgroundColor: "#282a65",
                                                    borderRadius: "5px",
                                                    padding: "1px"
                                                }}
                                            />
                                        </button>
                                    )}

                                    <div style={{ marginLeft: "8px" }}>
                                        <button
                                            type="button"
                                            title="Delete"
                                            onClick={this.openDeletePopUpForPatientMessage}
                                            style={{
                                                backgroundColor: "#ffffff",
                                                border: "none",
                                                padding: "0",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <img
                                                src="./assets/images/baseline_delete_white_24dp.png"
                                                alt="delete"
                                                style={{
                                                    width: "24px",
                                                    height: "24px",
                                                    backgroundColor: "#282a65",
                                                    borderRadius: "5px",
                                                    padding: "1px"
                                                }}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.showModal &&
                    <div className="modal" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content" style={{ height: "100%" }}>
                                <div className="modal-headers" style={{ alignItems: "center" }}>
                                    <h5 className="modal-title" style={{ color: "#282a65", display: "flex", justifyContent: "center" }}>
                                        {this.state.parentRuleId ? "Add Rule Component" : "Add Risk Rule"}
                                    </h5>
                                    <button type="button" className="close" onClick={this.handleModalClose}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {this.state.isRuleNameInputOpen &&
                                        <div>
                                            <label style={{ color: "black", fontWeight: "bold", display: "flex" }}>Risk Rule Name</label>
                                            <input
                                                type="text"
                                                value={this.state.riskRuleName}
                                                placeholder='Enter risk rule name'
                                                onChange={this.handleRiskRuleNameChange}
                                                style={{
                                                    border: "2px solid #777676",
                                                    borderRadius: "10px",
                                                    padding: "10px",
                                                    height: "2.5vh",
                                                }}
                                            />
                                            <hr />
                                        </div>
                                    }
                                    <label style={{ display: this.state.isEditingRule && "block", color: "black", fontWeight: "bold" }}>Rule type</label>
                                    <select value={this.state.selectedRuleType} onChange={this.handleDropdownChange}>
                                        <option value="" disabled selected hidden>Select Rule Type</option>
                                        <option value="JOURNAL_ENTRY_VALUE">Journal Entry Value</option>
                                        
                                    </select>
                                    <hr />
                                    {this.state.loadingJournals ? (
                                        <p>Loading configure option...</p>
                                    ) : (this.state.journals.length > 0 ? (
                                        <div>
                                            <label style={{ display: this.state.isEditingRule && "block", color: "black", fontWeight: "bold" }}>Journal</label>
                                            <select value={this.state.selectedJournalId} onChange={this.handleJournalDropdownChange}>
                                                <option value="" disabled selected hidden>Select Journal</option>
                                                {this.state.journals.map(journal => (
                                                    <option key={journal.id} value={journal.id}>{journal.title}</option>
                                                ))}
                                            </select>
                                        </div>
                                    ) : (
                                        <p></p>
                                    ))}
                                    <hr />

                                    {this.state.loadingRiskFactors ? (
                                        <p>Loading configure option...</p>
                                    ) : (
                                        this.state.riskFactors.length > 0 ? (
                                            <div>
                                                <label style={{ display: this.state.isEditingRule && "block", color: "black", fontWeight: "bold" }}>Risk Factor</label>
                                                <select value={this.state.selectedRiskFactorId} onChange={this.handleRiskFactorDropdownChange}>
                                                    <option value="" disabled selected hidden>Select Risk Factor</option>
                                                    {this.state.riskFactors.map(riskFactor => (
                                                        <option key={riskFactor.journalItemId} value={riskFactor.journalItemId}>{riskFactor.name}</option>
                                                    ))}
                                                </select>
                                                <hr />
                                                {this.state.riskFactorType === "INTEGER" && (
                                                    <div>
                                                        <label style={{ display: this.state.isEditingRule && "block", fontWeight: "bold", color: "black" }}>Comparison</label>
                                                        <select
                                                            value={this.state.selectedComparison}
                                                            onChange={this.handleComparisonChange}
                                                            style={{ display: this.state.selectedRuleType === "NO_JOURNAL_ENTRY" || this.state.selectedRuleType === "NO_MEDICATION_ADHERENCE" ? "none" : "block" }}
                                                        >

                                                            <option value="" disabled selected hidden>Select Comparison</option>
                                                            <option value="GREATER_THAN">Greater Than</option>
                                                            <option value="LESS_THAN">Less Than</option>
                                                            <option value="EQUALS_TO">Equal To</option>
                                                            <option value="GREATER_THAN_OR_EQUALS_TO">Greater Than or Equals</option>
                                                            <option value="LESS_THAN_OR_EQUALS_TO">Less Than or Equals</option>
                                                        </select>
                                                        <label style={{ display: this.state.isEditingRule && "block", fontWeight: "bold", color: "black", padding: "10px" }}>Baseline Type</label>
                                                        <select
                                                            value={this.state.selectedBaselineType}
                                                            onChange={this.handleBaseLinetypeChange}
                                                            style={{ display: this.state.selectedRuleType === "NO_JOURNAL_ENTRY" || this.state.selectedRuleType === "NO_MEDICATION_ADHERENCE" ? "none" : "block" }}
                                                        >

                                                            <option value="" disabled selected hidden>Select Baseline Type</option>
                                                            <option value="STATIC_BASELINE">Static Baseline</option>
                                                            <option value="FLOATING_BASELINE">Floating Baseline</option>

                                                        </select>
                                                        <hr />
                                                        {this.state.selectedRuleType === "NO_JOURNAL_ENTRY" && (
                                                            <div>
                                                                <label>Number of days without journal entry</label>
                                                                <input
                                                                    type="number"
                                                                    value={this.state.noJournalEntryDays}
                                                                    onChange={this.handleNumberChange}
                                                                    onWheel={this.blurOnWheel}
                                                                    style={{
                                                                        border: "2px solid #777676",
                                                                        borderRadius: "10px",
                                                                        padding: "10px",
                                                                        height: "2.5vh"
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        {(this.state.selectedRuleType === "JOURNAL_ENTRY_VALUE" && this.state.selectedBaselineType === "STATIC_BASELINE") && (
                                                            <div>
                                                                <label style={{ color: "black", fontWeight: "bold" }}>High Risk Value </label>
                                                                <input
                                                                    type="number"
                                                                    value={this.state.highThresholdValue}
                                                                    placeholder="Enter the high threshold value"
                                                                    onChange={this.handleHighThresholdChange}
                                                                    onWheel={this.blurOnWheel}
                                                                    style={{
                                                                        border: "2px solid #777676",
                                                                        borderRadius: "10px",
                                                                        padding: "10px",
                                                                        height: "2.5vh"
                                                                    }}
                                                                />
                                                                <hr />
                                                                <label style={{ color: "black", fontWeight: "bold" }}>Moderate Risk Value </label>
                                                                <input
                                                                    type="number"
                                                                    value={this.state.lowThresholdValue}
                                                                    placeholder="Enter the moderate threshold value"
                                                                    onChange={this.handleLowThresholdChange}
                                                                    onWheel={this.blurOnWheel}
                                                                    style={{
                                                                        border: "2px solid #777676",
                                                                        borderRadius: "10px",
                                                                        padding: "10px",
                                                                        height: "2.5vh"
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        {(this.state.selectedRuleType === "JOURNAL_ENTRY_VALUE" && this.state.selectedBaselineType === "FLOATING_BASELINE") && (
                                                            <div>
                                                                <label style={{ color: "black", fontWeight: "bold" }}>Baseline </label>
                                                                <select
                                                                    value={this.state.selectedBaseline}
                                                                    onChange={this.handleBaseLineChange}
                                                                    style={{ display: this.state.selectedRuleType === "NO_JOURNAL_ENTRY" || this.state.selectedRuleType === "NO_MEDICATION_ADHERENCE" ? "none" : "block" }}
                                                                >

                                                                    <option value="" disabled selected hidden>Select Baseline</option>
                                                                    <option value="YESTERDAY">Yesterday</option>
                                                                    <option value="CUSTOM_NUMBER_OF_DAYS_AGO">Custom Number of Days Ago</option>
                                                                    <option value="FIRST_DATAPOINT">First Data Point</option>


                                                                </select>
                                                                <hr />
                                                                {(this.state.selectedBaseline === "CUSTOM_NUMBER_OF_DAYS_AGO") && (
                                                                    <div>
                                                                        <label style={{ color: "black", fontWeight: "bold" }}>Number of days ago
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            value={this.state.numberOfDaysAgo}
                                                                            placeholder="Enter number of days ago"
                                                                            onChange={this.handleNumberOfDaysAgo}
                                                                            onWheel={this.blurOnWheel}
                                                                            min="1"
                                                                            style={{
                                                                                border: "2px solid #777676",
                                                                                borderRadius: "10px",
                                                                                padding: "10px",
                                                                                height: "2.5vh"
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                                {(this.state.selectedBaseline === "YESTERDAY" || this.state.selectedBaseline === "FIRST_DATAPOINT" || this.state.selectedBaseline === "CUSTOM_NUMBER_OF_DAYS_AGO") && (
                                                                    <div>
                                                                        <label style={{ color: "black", fontWeight: "bold", padding: "10px" }}>High Risk Deviation from Baseline
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            value={this.state.highRiskDeviation}
                                                                            placeholder="+/- number to reflect higher or lower"
                                                                            onChange={this.handleHighRiskDeviationChange}
                                                                            onWheel={this.blurOnWheel}
                                                                            style={{
                                                                                border: "2px solid #777676",
                                                                                borderRadius: "10px",
                                                                                padding: "10px",
                                                                                height: "2.5vh"
                                                                            }}
                                                                        />
                                                                        <label style={{ color: "black", fontWeight: "bold", padding: "10px" }}>Moderate Risk Deviation from Baseline
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            value={this.state.moderateRiskDeviation}
                                                                            placeholder="+/- number to reflect higher or lower"
                                                                            onChange={this.handleModerateRiskDeviationChange}
                                                                            onWheel={this.blurOnWheel}
                                                                            style={{
                                                                                border: "2px solid #777676",
                                                                                borderRadius: "10px",
                                                                                padding: "10px",
                                                                                height: "2.5vh"
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}

                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {(this.state.riskFactorType === "SELECT" || this.state.riskFactorType === "MULTISELECT" || this.state.riskFactorType === "BOOLEAN") && (
                                                    <div>
                                                        <div>
                                                            {this.state.riskFactorType === "SELECT" && (
                                                                <div style={{ border: "2px solid #777676", borderRadius: "10px", padding: "10px" }}>
                                                                    <label style={{ color: "black", fontWeight: "bold" }}>Select high risk option</label>
                                                                    {(this.state.riskFactors.find(rf => rf.journalItemId === this.state.selectedRiskFactorId) || { options: '' }).options.split(',').map((selectHighRiskOption, index) => (
                                                                        <div key={index}>
                                                                            <input
                                                                                type="radio"
                                                                                id={`selectHighRiskOption-${index}`}
                                                                                name="highRiskOptions"
                                                                                value={selectHighRiskOption}
                                                                                onChange={this.handleHighRiskOption}
                                                                                checked={this.state.highRiskOption === selectHighRiskOption}
                                                                            />
                                                                            <label htmlFor={`selectHighRiskOption-${index}`} style={{ marginLeft: "5px", color: "black" }}>{selectHighRiskOption}</label>
                                                                        </div>
                                                                    ))}
                                                                    <label style={{ color: "black", marginTop: "1.5vh", fontWeight: "bold" }}>Select moderate risk option</label>
                                                                    {(this.state.riskFactors.find(rf => rf.journalItemId === this.state.selectedRiskFactorId) || { options: '' }).options.split(',').map((selectMediumRiskOption, index) => (
                                                                        <div key={index}>
                                                                            <input
                                                                                type="radio"
                                                                                id={`selectMediumRiskOption-${index}`}
                                                                                name="mediumRiskOptions"
                                                                                value={selectMediumRiskOption}
                                                                                onChange={this.handleMediumRiskOption}
                                                                                checked={this.state.mediumRiskOption === selectMediumRiskOption}
                                                                            />
                                                                            <label htmlFor={`selectMediumRiskOption-${index}`} style={{ marginLeft: "5px", color: "black" }}>{selectMediumRiskOption}</label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            {this.state.riskFactorType === "MULTISELECT" && (
                                                                <div style={{ border: "2px solid #777676", borderRadius: "10px", padding: "10px" }}>
                                                                    <label style={{ color: "black", fontWeight: "bold" }}>Select high risk options</label>
                                                                    {(this.state.riskFactors.find(rf => rf.journalItemId === this.state.selectedRiskFactorId) || { options: '' }).options.split(',').map((multiSelectHighRiskOption, index) => (
                                                                        <div key={index}>
                                                                            <input
                                                                                style={{ marginLeft: "5px" }}
                                                                                type="checkbox"
                                                                                id={`multiSelectHighRiskOption-${index}`}
                                                                                value={multiSelectHighRiskOption}
                                                                                onChange={this.handleHighRiskOption}
                                                                                checked={this.state.highRiskOption.split(',').includes(multiSelectHighRiskOption)}
                                                                            />
                                                                            <label htmlFor={`multiSelectHighRiskOption-${index}`} style={{ marginLeft: "5px", color: "black" }}>{multiSelectHighRiskOption}</label>
                                                                        </div>
                                                                    ))}
                                                                    <label style={{ color: "black", marginTop: "1.5vh", fontWeight: "bold" }}>Select moderate risk options</label>
                                                                    {(this.state.riskFactors.find(rf => rf.journalItemId === this.state.selectedRiskFactorId) || { options: '' }).options.split(',').map((multiSelectMediumRiskOption, index) => (
                                                                        <div key={index}>
                                                                            <input
                                                                                style={{ marginLeft: "5px" }}
                                                                                type="checkbox"
                                                                                id={`multiSelectMediumRiskOption-${index}`}
                                                                                value={multiSelectMediumRiskOption}
                                                                                onChange={this.handleMediumRiskOption}
                                                                                checked={this.state.mediumRiskOption.split(',').includes(multiSelectMediumRiskOption)}
                                                                            />
                                                                            <label htmlFor={`multiSelectMediumRiskOption-${index}`} style={{ marginLeft: "5px", color: "black" }}>{multiSelectMediumRiskOption}</label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            {this.state.riskFactorType === "BOOLEAN" && (
                                                                <div style={{ border: "2px solid #777676", borderRadius: "10px", padding: "10px" }}>

                                                                    <label style={{ color: "black", fontWeight: "bold" }}>Select high risk option</label>
                                                                    {(this.state.riskFactors.find(rf => rf.journalItemId === this.state.selectedRiskFactorId) || { options: '' }).options.split(',').map((selectHighRiskOption, index) => (
                                                                        <div key={index}>
                                                                            <input
                                                                                type="radio"
                                                                                id={`selectHighRiskOption-${index}`}
                                                                                name="highRiskOptions"
                                                                                value={selectHighRiskOption}
                                                                                onChange={this.handleHighRiskOption}
                                                                                checked={this.state.highRiskOption === selectHighRiskOption}
                                                                            />
                                                                            <label htmlFor={`selectHighRiskOption-${index}`} style={{ marginLeft: "5px", color: "black" }}>{selectHighRiskOption}</label>
                                                                        </div>
                                                                    ))}

                                                                    <label style={{ color: "black", marginTop: "1.5vh", fontWeight: "bold" }}>Select moderate risk option</label>
                                                                    {(this.state.riskFactors.find(rf => rf.journalItemId === this.state.selectedRiskFactorId) || { options: '' }).options.split(',').map((selectMediumRiskOption, index) => (
                                                                        <div key={index}>
                                                                            <input
                                                                                type="radio"
                                                                                id={`selectMediumRiskOption-${index}`}
                                                                                name="mediumRiskOptions"
                                                                                value={selectMediumRiskOption}
                                                                                onChange={this.handleMediumRiskOption}
                                                                                checked={this.state.mediumRiskOption === selectMediumRiskOption}
                                                                            />
                                                                            <label htmlFor={`selectMediumRiskOption-${index}`} style={{ marginLeft: "5px", color: "black" }}>{selectMediumRiskOption}</label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}


                                                        </div>

                                                    </div>
                                                )}

                                            </div>
                                        ) : (
                                            <p>No risk factors available.</p>
                                        )
                                    )}

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary"
                                        onClick={this.saveRiskRule}
                                    >
                                        Save changes</button>
                                </div>

                            </div>
                        </div>
                    </div>
                }

                {this.state.showPatientMessageTranslation && this.state.patientMessageId && (
                    <TranslationPanel
                        entityType="patientMessage"
                        entityId={this.state.patientMessageId}
                        fields={[{ name: 'message', label: 'Message', rich: false }]}
                        sourceFields={{ message: this.state.patientMessageContent }}
                        title="Translate Patient Message"
                        procedureId={localStorage.getItem("procedureId")}
                        onClose={this.closePatientMessageTranslation}
                    />
                )}
            </div>
        );
    }

}

export default RiskRuleForProcedure;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/RiskRuleForProcedure.js